export default __webpack_public_path__ + "e9b3f1d3f5c7c31b4c0f7ffaa52d50ef.png";